<template>
    <div class="box_M">
        <div class="info_box_m detail">
            <div class="content">
                <div class="line">
                    <div class="label">姓名</div>
                    <div class="detail" v-text="detailContent.name"></div>
                </div>
                <div class="line">
                    <div class="label">办理事项</div>
                    <div class="detail" v-text="detailContent.businessMatterName"></div>
                </div>
                <div class="line">
                    <div class="label">办理业务</div>
                    <div class="detail" v-text="detailContent.businessParentName"></div>
                </div>
                <div class="line">
                    <div class="label">预约时间</div>
                    <div class="detail" v-text="detailContent.appointmentDate"></div>
                </div>
                <div class="line">
                    <div class="label">服务效率</div>
                    <div class="detail" v-text="serviceRange[detailContent.serviceEfficiency]"></div>
                </div>
                <div class="line">
                    <div class="label">服务态度</div>
                    <div class="detail" v-text="serviceRange[detailContent.serviceAttitude]"></div>
                </div>
                <div class="line">
                    <div class="label">状态</div>
                    <div class="detail" v-text="detailContent.state"></div>
                </div>
                <div class="line" v-if="detailContent.state === '正常'">
                    <div class="label">操作</div>
                    <div class="detail"><span class="btn" @click="cancelAppointment()">取消预约</span></div>
                </div>
                <div class="line" v-if="detailContent.state === '办理完成'">
                    <div class="label">服务评价</div>
                    <div class="detail"><span class="btn" @click="showAppointment = true">服务评价</span></div>
                </div>
            </div>
        </div>

        <!-- 服务评价弹窗 -->
        <van-dialog v-model="showAppointment" title="服务评价" show-cancel-button class="appointmentDialog" @confirm="handleUploadAppointment">
            <div class="line">
                <h3>服务效率</h3>
                <van-rate
                    v-model="detailContent.serviceAttitude"
                    :size="25"
                    color="#ffd21e"
                    void-icon="star"
                    void-color="#eee"
                />
            </div>
            <div class="line">
                <h3>服务态度</h3>
                <van-rate
                    v-model="detailContent.serviceEfficiency"
                    :size="25"
                    color="#ffd21e"
                    void-icon="star"
                    void-color="#eee"
                />
            </div>
            <div class="line">
                <h3>服务评价</h3>
                <van-field
                    v-model="detailContent.opinion"
                    rows="2"
                    autosize
                    type="textarea"
                    maxlength="50"
                    placeholder="请输入留言"
                    show-word-limit
                />
            </div>
        </van-dialog>

        <bottom-menu></bottom-menu>
    </div>
</template>

<script>
import BottomMenu from '@/components/mobile/BottomMenu.vue'
import { cancelAppointment, updateAppointment } from '@/service/api.js'

export default {
    components: { BottomMenu },
    data() {
        return {
            detailContent:{
                appointmentDate: '',
                businessMatterName: '',
                businessParentName: '',
                id: '',
                name: '',
                serviceAttitude: 0,
                serviceEfficiency: 0,
                state: ''
            },
            showAppointment:false,
            serviceRange:{
                1:'非常不满意',
                2:'不太满意',
                3:'一般',
                4:'比较满意',
                5:'非常满意'
            }
        }
    },
    methods: {
        cancelAppointment(){
            cancelAppointment(`id=${this.detailContent.id}`).then(data=>{
                if (data.code!==0) {
                    this.$toast(data.msg)
                }else{
                    this.$toast('取消成功')
                    this.$router.push({name:'M_PersonalAppointment'})
                }
            })
        },
        // 提交服务评价
        handleUploadAppointment(){
            this.showAppointment = false
            const pageParams = `id=${this.detailContent.id}&serviceEfficiency=${this.detailContent.serviceEfficiency}&serviceAttitude=${this.detailContent.serviceAttitude}&opinion=${this.detailContent.opinion}`
            updateAppointment(pageParams).then(data=>{
                if (data.code!==0) {
                    this.$toast(data.msg)
                }else{
                    this.$toast('感谢您的评价')
                }
            })
        }
    },
    mounted () {
        this.detailContent = this.$route.query
        this.detailContent.serviceAttitude = parseInt(this.detailContent.serviceAttitude)
        this.detailContent.serviceEfficiency = parseInt(this.detailContent.serviceEfficiency)
    },
}

</script>